"use strict";
var distill;
(function (distill) {
    var dashboards;
    (function (dashboards) {
        class GridStackCanvas extends appn.designerv2.CanvasBase {
            constructor(options) {
                super();
                this._gridOptions = options;
            }
            render(design) {
                if (this._grid)
                    this._grid.destroy();
                dashboards.charts.disposeAll();
                const $workspace = $('.workspace');
                $workspace.empty();
                design === null || design === void 0 ? void 0 : design.components.forEach((component) => {
                    const componentEl = this.createComponentElement(component);
                    $workspace.append(componentEl);
                });
                this._grid = GridStack.init(this._gridOptions, $workspace.find('.grid-stack').get(0));
                this.attachGridEvents();
            }
            bindDragIn() {
                GridStack.setupDragIn('.toolButton:not(.upgradeReq)', {
                    appendTo: 'body',
                    helper: 'clone'
                });
            }
            attachGridEvents() {
                this._grid.on('added', (event, items) => {
                    items.forEach(item => {
                        var _a, _b, _c, _d, _e, _f;
                        const el = item.el;
                        if (!el.classList.contains('toolButton'))
                            return;
                        el.classList.remove('toolButton');
                        const componentType = el.getAttribute('rel');
                        if (!componentType)
                            return;
                        const gs_w = Number(el.getAttribute('gs-w'));
                        const gs_h = Number(el.getAttribute('gs-h'));
                        const newComponent = dashboards.designer.addComponent(componentType, {
                            x: (_a = item.x) !== null && _a !== void 0 ? _a : 0, y: (_b = item.y) !== null && _b !== void 0 ? _b : 0, w: (_d = (_c = item.w) !== null && _c !== void 0 ? _c : gs_w) !== null && _d !== void 0 ? _d : 4, h: (_f = (_e = item.h) !== null && _e !== void 0 ? _e : gs_h) !== null && _f !== void 0 ? _f : 4
                        });
                        if (!newComponent)
                            return;
                        let newComponentElement = this.createComponentElement(newComponent);
                        this._grid.removeWidget(el);
                        this._grid.addWidget(newComponentElement[0]);
                        $('.component.selected').removeClass('selected');
                        newComponentElement.addClass('selected');
                        dashboards.designer.setSelectedComponent(newComponent.id);
                    });
                });
                this._grid.on('change', (event, items) => {
                    items === null || items === void 0 ? void 0 : items.forEach(item => {
                        if (item.id)
                            dashboards.designer.updateComponentPosition(item.id, { x: item.x, y: item.y, w: item.w, h: item.h });
                    });
                });
                this._grid.on('removed', (event, items) => {
                    items === null || items === void 0 ? void 0 : items.forEach(item => {
                        if (item.id)
                            dashboards.designer.deleteComponent(item.id);
                    });
                });
            }
            onCreateComponentElement(component, $template) {
                $template.attr('gs-id', component.id);
                if (component.gridPosition) {
                    $template.attr('gs-x', component.gridPosition.x);
                    $template.attr('gs-y', component.gridPosition.y);
                    $template.attr('gs-w', component.gridPosition.w);
                    $template.attr('gs-h', component.gridPosition.h);
                }
            }
            onUpdateComponentElement(element, component) {
                var _a;
                if (component.children && component.children.length > 0) {
                    const groupGridStack = element.find('.grid-stack');
                    groupGridStack.empty();
                    component.children.forEach(childComponent => {
                        const childElement = this.createComponentElement(childComponent);
                        groupGridStack.append(childElement);
                    });
                }
                const dashComp = component;
                const $header = element.find('.card-header');
                if ($header.length) {
                    const headerBg = (_a = dashComp.styling) === null || _a === void 0 ? void 0 : _a.headerBgColor;
                    if (headerBg && headerBg !== 'transparent')
                        $header.css('background-color', headerBg);
                    else
                        $header.css('background-color', '');
                }
            }
            removeComponent(componentId) {
                if (componentId && this._grid) {
                    const el = document.getElementById(componentId);
                    if (el)
                        this._grid.removeWidget(el);
                }
            }
        }
        dashboards.GridStackCanvas = GridStackCanvas;
    })(dashboards = distill.dashboards || (distill.dashboards = {}));
})(distill || (distill = {}));
